module.exports = __webpack_public_path__ + "media/images/smart_phone/products/chicken-4164d2bec52ed6616491adefb8389015.jpeg";